import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import React, {PropsWithChildren} from 'react'
import {StyledButton} from '../../styled-button'
import {classes, st} from './footer.st.css'

interface FooterProps {
  primaryButtonLabel: string
  primaryButtonClick: (event: React.MouseEvent) => void
  secondaryButtonLabel: string
  secondaryButtonClick: (event: React.MouseEvent) => void
}

export const Footer = ({
  children,
  primaryButtonLabel,
  primaryButtonClick,
  secondaryButtonLabel,
  secondaryButtonClick,
}: PropsWithChildren<FooterProps>) => {
  const {isMobile} = useEnvironment()
  return (
    <div className={classes.footerContainer}>
      {children}
      <div className={st(classes.buttonContainer, {mobile: isMobile})}>
        <StyledButton
          fullWidth={isMobile}
          secondary
          onClick={secondaryButtonClick}
          dataHook={DH.SECONDARY_BUTTON}
          small
        >
          {secondaryButtonLabel}
        </StyledButton>
        <StyledButton
          fullWidth={isMobile}
          className={classes.confirmButton}
          onClick={primaryButtonClick}
          dataHook={DH.PRIMARY_BUTTON}
          small
        >
          {primaryButtonLabel}
        </StyledButton>
      </div>
    </div>
  )
}
